export default {
	TODOS: 'companies/:company_id/todos/',
}
